import { updateTransactionMessageMetadata } from './api';

const ROLE_CUSTOMER = 'customer';
const ROLE_PROVIDER = 'provider';

const senderRoleToSeenMetadata = senderRole => {
  if (senderRole === ROLE_CUSTOMER) {
    return {
      lastMessageSeenByCustomer: true,
      lastMessageSeenByProvider: false,
    };
  }
  if (senderRole === ROLE_PROVIDER) {
    return {
      lastMessageSeenByCustomer: false,
      lastMessageSeenByProvider: true,
    };
  }
  return {};
};

export const sendMessageWithMetadata = ({
  sdk,
  transactionId,
  message,
  senderRole,
  currentMetadata = {},
}) => {
  return sdk.messages.send({ transactionId, content: message }).then(response => {
    const normalizedSenderRole =
      senderRole === ROLE_PROVIDER || senderRole === ROLE_CUSTOMER ? senderRole : ROLE_CUSTOMER;
    const metadata = {
      ...currentMetadata,
      lastMessage: message,
      lastMessageSentBy: normalizedSenderRole,
      lastMessageSentAt: Date.now(),
      ...senderRoleToSeenMetadata(normalizedSenderRole),
    };

    return updateTransactionMessageMetadata({
      transactionId,
      metadata,
    })
      .catch(() => null)
      .then(() => response);
  });
};
